import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        d="M18.3701 40.5782C18.3701 40.5782 16.6901 39.9082 15.1201 38.8182C12.3101 36.8582 7.31008 33.9283 2.08008 35.6283C2.08008 35.6283 2.96007 29.5683 3.40007 21.2083C3.84007 12.8483 3.46007 3.57825 3.46007 3.57825C3.46007 3.57825 7.25007 7.75822 9.45007 12.1782C11.6501 16.5982 10.5501 28.1383 10.5501 28.1383L14.6201 21.6383C14.6201 21.6383 14.4001 24.4983 15.7201 28.9083C16.8201 32.5483 18.1801 36.2182 18.3701 40.5782Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10.3303 22.6283C10.3303 22.6283 6.26025 26.2583 2.51025 31.6583"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.5501 19.5482C10.5501 19.5482 6.26006 21.3083 3.06006 25.1583"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.2201 14.7083C10.2201 14.7083 5.93008 16.2483 3.83008 18.2283"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.78014 13.0482C9.78014 13.0482 5.49014 14.5882 3.39014 16.5682"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.7701 26.2683C10.7701 26.2683 7.47012 30.8883 6.37012 34.8583"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M14.7303 26.8182C14.7303 26.8182 11.9803 30.8883 11.3203 36.2883"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.2801 29.3483C15.2801 29.3483 13.6301 33.6383 13.9601 37.7183"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M34.8799 40.5782C34.8799 40.5782 36.5599 39.9082 38.1299 38.8182C40.9399 36.8582 45.9399 33.9283 51.1699 35.6283C51.1699 35.6283 50.2899 29.5683 49.8499 21.2083C49.4099 12.8483 49.7899 3.57825 49.7899 3.57825C49.7899 3.57825 45.9999 7.75822 43.7999 12.1782C41.5999 16.5982 42.6999 28.1383 42.6999 28.1383L38.6299 21.6383C38.6299 21.6383 38.8499 24.4983 37.5299 28.9083C36.4299 32.5483 35.0699 36.2182 34.8799 40.5782Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M42.9199 22.6283C42.9199 22.6283 46.9899 26.2583 50.7399 31.6583"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.6997 19.5482C42.6997 19.5482 46.9897 21.3083 50.1897 25.1583"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M43.0298 14.7083C43.0298 14.7083 47.3198 16.2483 49.4198 18.2283"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M43.4697 13.0482C43.4697 13.0482 47.7597 14.5882 49.8597 16.5682"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.48 26.2683C42.48 26.2683 45.78 30.8883 46.88 34.8583"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M38.5098 26.8182C38.5098 26.8182 41.2598 30.8883 41.9198 36.2883"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M37.96 29.3483C37.96 29.3483 39.61 33.6383 39.28 37.7183"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
